<!--
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author:
 * @Date: 2020-07-14 09:06:21
 * @LastEditTime: 2020-07-24 15:36:34
 * @LastEditors: zhanglei
 * @Description:
 * @FilePath: /desktop/src/views/NavMenu/NavMenu.vue
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
-->

<template>
  <div class="nav-menu-con">
    <!-- 项目的标题 start -->
    <a>
      <div v-bind:class="['header-title-unfold', isCollapse ? 'fold' : 'unfold']">
        <div v-if="!isCollapse"> {{$t('header.name')}}</div>
        <img v-if="isCollapse"
             :src="imgUrl"
             alt="logo"
             class="logo">
      </div>
    </a>
    <!-- 项目的标题 end -->
    <!-- slider菜单 start -->
    <el-menu router
             unique-opened
             mode="vertical"
             :default-active="defaultActive"
             class="el-menu-vertical"
             :collapse="isCollapse">
      <template v-for="(item,index) in menu.menuList">
        <!-- 有子菜单 start -->
        <el-submenu v-if="item.childs"
                    :index="index+''"
                    :key="item.id"
                    :id="item.name"
                    :template_id="item.templateId"
                    @click="select_menu($event,$event.$attrs.template_id)">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{item.name}}</span>
          </template>
          <el-menu-item v-for="(subItem) in item.childs"
                        :key="subItem.id"
                        :id="item.name"
                        :index="subItem.route"
                        :name="subItem.name"
                        :template_id="subItem.templateId"
                        @click="select_menu($event,$event.$attrs.template_id)">
            {{subItem.name}}
          </el-menu-item>
        </el-submenu>
        <!-- 有子菜单 end -->
        <!-- 无子菜单 start -->
        <el-menu-item v-if="!item.childs"
                      :index="item.route"
                      :key="item.id"
                      :id="item.name"
                      :template_id="item.templateId"
                      @click="select_menu($event,$event.$attrs.template_id)">
          <i :class="item.icon"></i>
          <span slot="title">{{item.name}}</span>
        </el-menu-item>
        <!-- 无子菜单 end -->
      </template>
    </el-menu>
    <!-- slider菜单 end -->
  </div>
</template>

<script>
import { menuMock } from './mock'
import { mapMutations, mapState, mapActions } from 'vuex'
import { ADD_MENU } from '../../store/mutation-types'
import common from '@/utils/common'
import { setStore, getStore } from '@/utils/store'
export default {
  data () {
    return {
      // 左侧栏 上面的宝马图标
      imgUrl: require('../../imgs/white_logo.png'),
      // 默认展示的slider哪一项
      defaultActive: '/feeAudit',
      // mock
      mockMenu: [
        {
          createdAt: null,
          icon: "el-icon-present",
          id: "3a205310864f47c0b2151395b8bf09e7",
          level: 1,
          name: "审批管理",
          order: 2,
          parentId: null,
          path: null,
          route: null,
          templateId: null,
          type: null,
          updatedAt: null,
          childs: [
            {
              createdAt: null,
              icon: null,
              id: "b1b7249ebf2440df8d37aab4625721f0",
              level: 2,
              name: "新生儿礼品审批",
              order: 1,
              parentId: "3a205310864f47c0b2151395b8bf09e7",
              path: null,
              route: "/feeAudit",
              templateId: "ffb57ef8cf1111ea85df2816adba7c54",
              type: null,
              updatedAt: null,
              childs: []
            }
          ]
        }
      ]
    }
  },
  mounted () {
    // 处理每次刷新的时候 都设置为当前的默认值
    this.defaultActive = this.$route.path;
    // 暂时放入mock数据 将来调用接口的时候 需要改变附值的位置
    // this.ADD_MENU(menuMock)
  },
  created () {
    this.getMenu()
  },
  computed: {
    ...mapState({
      menu: state => state.menu,
      isCollapse: state => state.menu.isCollapse
    })
  },
  methods: {
    ...mapActions(['getUserMenu']),
    ...mapMutations([
      ADD_MENU
    ]),
    /**
     * 获取路由list
     */
    getMenu () {
      this.getUserMenu().then((res) => {
        for (let i = 0; i < res.menus.length; i++) {
          if (res.menus[i].childs.length == 0) {
            delete res.menus[i].childs;
          }
        }
        console.log(res.menus)
        this.ADD_MENU(res.menus);
      })
    },
    /**
     * 获取当前路由的模板ID
     */
    select_menu (a, e) {
      console.log(a)
      console.log(a.$attrs.name)
      common.templateId = e;
      setStore({ name: 'route_parent', content: a.$attrs.id, type: true })
      if (a.$attrs.name != undefined) {
        setStore({ name: 'route_son', content: a.$attrs.name, type: true })
      } else {
        setStore({ name: 'route_son', content: '', type: true })
      }
      setStore({ name: 'route', content: a.index, type: true })
      setStore({ name: 'templateId', content: e, type: true })
    }
  }
}
</script>
<style lang="less">
/* 左侧导航栏 样式修改 */
.nav-menu-con {
  font-size: 14px;
  height: 100%;
  background-color: #001529;
  overflow-y: auto;
  .header-title-unfold {
    line-height: 56px;
    height: 56px;
    text-align: center;
    background: #002140;
    color: #fff;
    font-weight: bold;
    position: fixed;
    top: 0;
    left: 0;
    white-space: nowrap;
    width: 256px;
    z-index: 1;
    transition: width 0.1s;
  }
  .unfold {
    width: 256px;
    overflow: hidden;
    transition: width 0.7s;
  }
  .fold {
    width: 64px;
  }
  .logo {
    width: 30px;
    padding-top: 13px;
  }
  .el-menu {
    border-right: 0px;
  }
  .el-submenu__title {
    color: #a5a9ad;
    background: #001529;
  }
  .el-submenu.is-active .el-submenu__title {
    color: #fff !important;
    i {
      color: #fff !important;
    }
  }
  .el-menu-vertical:not(.el-menu--collapse) {
    width: 256px;
    margin-top: 56px;
  }
  .el-menu--collapse {
    margin-top: 56px;
  }
  .el-menu-item [class^='el-icon-'] {
    margin-bottom: 2px;
  }
  .el-submenu [class^='el-icon-'] {
    margin-bottom: 2px;
  }
  .el-submenu .el-menu-item {
    background: #000c17;
    padding-left: 51px !important;
  }
  .el-menu-item.is-active {
    background: #1990ff !important;
    color: rgba(255, 255, 255, 1) !important;
  }
  .el-menu-item {
    background: #001529;
    color: #a5a9ad;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/NavMenu/NavMenu.vue